var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCampaignPerformance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 10.8954 4.89543 10 6 10H15C16.1046 10 17 10.8954 17 12V12C17 13.1046 16.1046 14 15 14H6C4.89543 14 4 13.1046 4 12V12Z",
    stroke: "#868687",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18C12 20.2091 13.7909 22 16 22C18.2091 22 20 20.2091 20 18C20 15.7909 18.2091 14 16 14C15.8007 14 15.6047 14.0146 15.4132 14.0427M12 18C12 15.9902 13.4823 14.3266 15.4132 14.0427M12 18H6C4.89543 18 4 17.1046 4 16C4 14.8954 4.89543 14 6 14H15C15.1417 14 15.2799 14.0147 15.4132 14.0427",
    stroke: "#868687",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.58579L12.7071 2.29289C12.3166 1.90237 11.6834 1.90237 11.2929 2.29289L10 3.58579M12 7L12 2.58579",
    stroke: "#868687",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCampaignPerformance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/campaign_performance.d0661c909c488be1e9df71008c04a44f.svg";